module.exports = __webpack_public_path__ + "media/images/unsplash_img_03-p-130x130q80-ef034c5b96daf05ca3b88d87d3ed3fa9.jpeg";